import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { RootStore } from "./stores/root";
import { StoreProvider } from "./utils/store-provider";

import { BrowserRouter } from "react-router-dom";

import "./index.scss";

const initialRoot = new RootStore();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <StoreProvider value={initialRoot}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StoreProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();